import { has } from "../../../../utils/menu-context";
import store from "../../../../store";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, initialModel }) => {
            const { menuContext, isCanEditAllState } = props;
            let result = false;
            if (!has({ menuContext, key: 'canEdit' }) || initialModel.isActive === false) return false;
            if (isCanEditAllState) { return true; }
            result = ['Wait'].includes(initialModel.refLabAnalysisStatus?.key)
                || (has({ menuContext, key: 'canApprove' }) && ['Reviewed'].includes(initialModel.refLabAnalysisStatus?.key))
                || result;
            return result
        },
        canReview: ({ props, modelRef }) => {
            let result = false;
            const { menuContext, refExtCenterTypeKey } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (!has({ menuContext, key: 'canReview' }) || modelRef.isActive === false) return false;
            if (userInfo?.refDepartment?.id !== modelRef.refDepartment?.id
                && (modelRef.refDepartment?.refParent?.id !== userInfo?.refDepartment?.id)) return false;
            if (!refExtCenterTypeKey) {
                const incompleteCounts = modelRef?.topics?.flatMap(d=>d?.inputs || []).filter(d=>d.realValue == null)?.length
                if (incompleteCounts > 0) return false
            }
            result = ['Wait'].includes(modelRef.refLabAnalysisStatus?.key) || result;
            return result
        },
        canCalculate: ({ props, initialModel }) => {
            let result = false;
            const { menuContext, refExtCenterTypeKey, isCanEditAllState } = props;
            if (!has({ menuContext, key: 'canCalculate' })) return false;
            if (isCanEditAllState) { return true; }
            if (initialModel.isActive === false || refExtCenterTypeKey) return false;
            result = ['Wait', 'Reviewed'].includes(initialModel.refLabAnalysisStatus?.key) || result;
            return result
        },
        canApprove: ({ props, modelRef }) => {
            let result = false;
            const { menuContext, refExtCenterTypeKey } = props;
            const refLabTypeKey = modelRef?.refLabType?.key;
            const userInfo = store.state.resource.auth.info?.user;
            if (!has({ menuContext, key: 'canApprove' }) || modelRef.isActive === false) return false;
            if (!((userInfo?.refDepartment?.id == modelRef.refDepartment?.id) || (modelRef.refDepartment?.refParent?.id == userInfo?.refDepartment?.id)))  {
                return false
            }
            if (refExtCenterTypeKey) {
                let incompleteCounts = []
                    if (refLabTypeKey !== 'labPhysic') {
                        incompleteCounts = modelRef?.topics?.flatMap(d=>d.inputs).filter(d=>d?.realValue == null).length
                    } else {
                        incompleteCounts = modelRef?.topics?.filter(d=>d?.refTopicAnalysisStatus == null).length
                    }
                if (incompleteCounts > 0) { return false; }
            } else {
                const incompleteCounts = modelRef?.topics?.filter(d=>!d.refTopicAnalysisStatus).length;
                if (incompleteCounts > 0) { return false; }
            }
            result = ['Reviewed'].includes(modelRef.refLabAnalysisStatus?.key) || result;
            return result
        },
    }
}